import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CopyIcon from '@/lib/assets/copy.svg';
import styles from './OrdersInformation.module.scss';

const OrdersInformation = ({ orderInformations = null, reference }) => {
    const { t } = useTranslation();
    const onClickCopyIcon = React.useCallback(() => {
        navigator.clipboard.writeText(reference);
    }, [reference]);

    return (
        <div className={styles.information}>
            <div className={styles.information_header}>{t('informations')}</div>
            <div className={styles.information_content}>
                {orderInformations &&
                    <div className={styles.order_information}>
                        {t('orderInformation')}
                        {orderInformations.map((orderInfo) => (
                            <p>{orderInfo.name}</p>
                        ))}
                    </div>
                }
                <div className={styles.order_reference}>
                    {t('orderReference')}
                    <div className={styles.order_reference_content}>
                        <p>{reference}</p>
                        <div className={styles.copy_icon} onClick={onClickCopyIcon}>
                            <CopyIcon />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

OrdersInformation.propTypes = {
    reference: PropTypes.string,
};

export default OrdersInformation;
